export const tableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Nº',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Grupo',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Subcategoría',
                    type: 'custom-html',
                    key: 'level_7_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Documento normativo específico para FSSC',
                    type: 'custom-html',
                    key: 'level_8b',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Estado',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (value) => {
                        return `<span class="badge badge-sm badge-pill badge-primary">${value.name}</span>`;
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}